(function () {
    'use strict';

    /**
     * @desc ui.select expanded widget
     * @example <div data-elogbooks-select-site-multiple ng-model="vm.model"></div>
     */
    angular
        .module('elogbooksDirectives')
        .directive('elbSelectAccess', function ($uibModal, apiClient, lodash, $q, $timeout, messenger) {
            return {
                restrict: 'A',
                templateUrl: '/modules/directives/form-elements/select-access/select-access.html',
                scope: {
                    model: '=ngModel'
                },
                require: ['ngModel'],
                controller: ['$scope', function($scope) {
                    var defaultModel = {
                        link : null,
                        loading : false,
                        selectedLoading : false,
                        responseKeyPath: 'data',
                        itemHrefPath: '_links.self.href',
                        itemValuePath: 'name',
                        allTitle: 'ALL_SITES',
                        selectedTitle: 'SELECTED_SITES',
                        keyword: null,
                        selectedItems: [],
                        items: [],
                        searchKey: 'name',
                        map : map,
                        getResponseData : getResponseData,
                        filterResponse : filterResponse,
                    };

                    $scope.add = addAction;
                    $scope.remove = removeAction;
                    $scope.searchDelayed = searchDelayed;

                    var lastResponse = null;
                    var selectedLastResponse = null;
                    var selectedSearchResponse = null;
                    var selectedSearchTimer = null;
                    var manuallyReturnedItems = [];
                    var selectedHasMoreOptionsReal = false;
                    var searchToken = 0;
                    var selectedSearchToken = 0;

                    //Merge with defaults
                    $scope.model = lodash.merge(defaultModel, $scope.model);

                    $scope.itemsHtmlModel = {
                        isLoading: !!$scope.model.loading,
                        selected: [],
                        options: [],
                        hasMoreOptions: false,
                        loadNext: loadNextOptions
                    };

                    $scope.selectedItemsHtmlModel = {
                        isLoading: !!$scope.model.selectedLoading,
                        selected: [],
                        options: [],
                        hasMoreOptions: false,
                        loadNext: loadNextSelectedOptions
                    };

                    $scope.$watch('model.loading', function (isLoading) {
                        $scope.itemsHtmlModel.isLoading = !!isLoading;
                    });

                    $scope.$watch('model.selectedLoading', function (isLoading) {
                        $scope.selectedItemsHtmlModel.isLoading = !!isLoading;
                    });

                    $scope.$watch('model.items', function (items) {

                        $scope.itemsHtmlModel.options = (items || []).map(ensureId);
                    });

                    $scope.$watchCollection('model.selectedItems', refreshSelectedOptions);
                    $scope.$watchCollection('model.pendingAdditions', refreshSelectedOptions);
                    $scope.$watchCollection('model.pendingRemovals', refreshSelectedOptions);

                    $scope.$watch('model.selectedItemsFilter', function (keyword, oldKeyword) {
                        if (keyword === oldKeyword) {
                            return;
                        }

                        if (!$scope.model.selectedLink) {
                            refreshSelectedOptions();
                            return;
                        }

                        if (!keyword) {
                            $timeout.cancel(selectedSearchTimer);
                            selectedSearchToken++;
                            selectedSearchResponse = null;
                            $scope.selectedItemsHtmlModel.isLoading = false;
                            updateSelectedHasMoreOptions();
                            refreshSelectedOptions();
                            return;
                        }

                        $timeout.cancel(selectedSearchTimer);
                        selectedSearchTimer = $timeout(searchSelectedAction, 250);
                    });

                    $scope.$watch('model.initialResponse', function (response) {
                        if (!response) {
                            return;
                        }

                        lastResponse = response;
                        updateHasMoreOptions();
                    });

                    $scope.$watch('model.initialSelectedResponse', function (response) {
                        if (!response) {
                            return;
                        }

                        selectedLastResponse = response;
                        updateSelectedHasMoreOptions();
                    });

                    function ensureId(item) {
                        if (item && typeof item.id === 'undefined') {
                            item.id = item.href;
                        }

                        return item;
                    }

                    function syncSelectedOptions() {
                        var keyword = ($scope.model.selectedItemsFilter || '').toLowerCase();
                        var items = $scope.model.selectedItems || [];

                        var filtered = keyword
                            ? items.filter(function (item) {
                                return (item.value || '').toLowerCase().indexOf(keyword) >= 0;
                            })
                            : items;

                        $scope.selectedItemsHtmlModel.options = lodash.orderBy(filtered, function (item) {
                            return (item.value || '').toLowerCase();
                        }).map(ensureId);
                        applySelectedHasMoreOptions();
                    }

                    function refreshSelectedOptions() {
                        if (selectedSearchResponse) {
                            applySelectedSearchResults();
                        } else {
                            syncSelectedOptions();
                        }
                    }

                    function searchSelectedAction() {
                        var keyword = $scope.model.selectedItemsFilter;

                        if (!keyword || !$scope.model.selectedLink) {
                            return;
                        }

                        var token = ++selectedSearchToken;

                        $scope.selectedItemsHtmlModel.isLoading = true;

                        var searchParams = {};
                        searchParams[$scope.model.selectedSearchKey || 'name'] = keyword;

                        apiClient.get($scope.model.selectedLink, angular.extend({}, searchParams, $scope.model.selectedSearchParams)).then(function (response) {
                            // A newer search (or a cleared filter) has already superseded this request.
                            if (token !== selectedSearchToken) {
                                return;
                            }

                            $scope.selectedItemsHtmlModel.isLoading = false;

                            if (!response) {
                                messenger.error('REQUEST_ERROR');
                                return;
                            }

                            selectedSearchResponse = response;
                            applySelectedSearchResults();
                        });
                    }

                    function applySelectedSearchResults() {
                        if (!selectedSearchResponse) {
                            return;
                        }

                        var keyword = ($scope.model.selectedItemsFilter || '').toLowerCase();
                        var serverMatches = $scope.model.filterResponse(selectedSearchResponse);

                        var pendingMatches = ($scope.model.pendingAdditions || []).filter(function (item) {
                            return (item.value || '').toLowerCase().indexOf(keyword) >= 0;
                        });

                        var results = lodash.unionBy(serverMatches, pendingMatches, 'href');
                        results = lodash.differenceBy(results, $scope.model.pendingRemovals || [], 'href');

                        $scope.selectedItemsHtmlModel.options = lodash.orderBy(results, function (item) {
                            return (item.value || '').toLowerCase();
                        }).map(ensureId);

                        selectedHasMoreOptionsReal = !!selectedSearchResponse.getLink('next');
                        $scope.selectedItemsHtmlModel.hasMoreOptions = selectedHasMoreOptionsReal;
                    }

                    function loadNextSelectedSearchPage() {
                        if (!selectedSearchResponse || !selectedSearchResponse.getLink('next')) {
                            $scope.selectedItemsHtmlModel.hasMoreOptions = false;
                            return $q.resolve();
                        }

                        return selectedSearchResponse.more().then(function () {
                            applySelectedSearchResults();
                        });
                    }

                    function updateHasMoreOptions() {
                        $scope.itemsHtmlModel.hasMoreOptions = !!(lastResponse && lastResponse.getLink('next'));
                    }

                    function updateSelectedHasMoreOptions() {
                        selectedHasMoreOptionsReal = !!(selectedLastResponse && selectedLastResponse.getLink('next'));
                        applySelectedHasMoreOptions();
                    }

                    function applySelectedHasMoreOptions() {
                        var isFiltering = !!($scope.model.selectedItemsFilter || '').length;

                        $scope.selectedItemsHtmlModel.hasMoreOptions = !isFiltering && selectedHasMoreOptionsReal;
                    }

                    function removeAction () {
                        var selected = ($scope.selectedItemsHtmlModel.selected || []).map(toPlainOption);

                        $scope.model.selectedItems = lodash.differenceBy($scope.model.selectedItems, selected, 'href');
                        $scope.model.items = lodash.unionBy($scope.model.items, selected, 'href');
                        manuallyReturnedItems = lodash.unionBy(manuallyReturnedItems, selected, 'href');

                        // If this was added this session, cancel the pending addition rather than reporting a removal.
                        var pendingAdditions = $scope.model.pendingAdditions || [];
                        var genuineRemovals = lodash.differenceBy(selected, pendingAdditions, 'href');

                        $scope.model.pendingAdditions = lodash.differenceBy(pendingAdditions, selected, 'href');
                        $scope.model.pendingRemovals = lodash.unionBy($scope.model.pendingRemovals || [], genuineRemovals, 'href');
                    }

                    function addAction () {
                        var selected = ($scope.itemsHtmlModel.selected || []).map(toPlainOption);

                        $scope.model.items = lodash.differenceBy($scope.model.items, selected, 'href');
                        $scope.model.selectedItems = lodash.unionBy($scope.model.selectedItems, selected, 'href');
                        manuallyReturnedItems = lodash.differenceBy(manuallyReturnedItems, selected, 'href');

                        // If this was a pending removal, cancel it rather than reporting an addition.
                        var pendingRemovals = $scope.model.pendingRemovals || [];
                        var genuineAdditions = lodash.differenceBy(selected, pendingRemovals, 'href');

                        $scope.model.pendingRemovals = lodash.differenceBy(pendingRemovals, selected, 'href');
                        $scope.model.pendingAdditions = lodash.unionBy($scope.model.pendingAdditions || [], genuineAdditions, 'href');
                    }

                    function toPlainOption(item) {
                        return { href: item.href, value: item.value };
                    }

                    function searchAction() {
                        $scope.model.loading = true;
                        var token = ++searchToken;

                        var searchParams = {};
                        searchParams[$scope.model.searchKey] = $scope.model.keyword;

                        apiClient.get($scope.model.link, angular.extend({}, searchParams, $scope.model.searchParams)).then(function (response) {
                            // A newer search has already superseded this request.
                            if (token !== searchToken) {
                                return;
                            }

                            if (!response) {
                                $scope.model.loading = false;
                                messenger.error('REQUEST_ERROR');
                                return;
                            }

                            lastResponse = response;
                            var results = lodash.unionBy($scope.model.filterResponse(response), matchingManuallyReturnedItems(), 'href');
                            $scope.model.items = lodash.differenceBy(results, $scope.model.selectedItems, 'href');
                            $scope.model.loading = false;
                            updateHasMoreOptions();
                        });
                    }

                    function matchingManuallyReturnedItems() {
                        var keyword = ($scope.model.keyword || '').toLowerCase();

                        return keyword
                            ? manuallyReturnedItems.filter(function (item) {
                                return (item.value || '').toLowerCase().indexOf(keyword) >= 0;
                            })
                            : manuallyReturnedItems;
                    }

                    function loadNextOptions() {
                        if (!lastResponse || !lastResponse.getLink('next')) {
                            $scope.itemsHtmlModel.hasMoreOptions = false;
                            return $q.resolve();
                        }

                        return lastResponse.more().then(function () {
                            var results = lodash.unionBy($scope.model.filterResponse(lastResponse), matchingManuallyReturnedItems(), 'href');
                            $scope.model.items = lodash.differenceBy(results, $scope.model.selectedItems, 'href');
                            updateHasMoreOptions();
                        });
                    }

                    function loadNextSelectedOptions() {
                        if (selectedSearchResponse) {
                            return loadNextSelectedSearchPage();
                        }

                        if (!selectedLastResponse || !selectedLastResponse.getLink('next')) {
                            $scope.selectedItemsHtmlModel.hasMoreOptions = false;
                            return $q.resolve();
                        }

                        var beforeLength = ($scope.model.getResponseData(selectedLastResponse) || []).length;

                        return selectedLastResponse.more().then(function () {
                            var newItems = $scope.model.filterResponse(selectedLastResponse).slice(beforeLength);
                            newItems = lodash.differenceBy(newItems, manuallyReturnedItems, 'href');
                            $scope.model.selectedItems = lodash.unionBy($scope.model.selectedItems || [], newItems, 'href');
                            updateSelectedHasMoreOptions();
                        });
                    }

                    function searchDelayed() {
                        $timeout.cancel($scope.timer);
                        $scope.timer = $timeout(searchAction, 250);
                    }

                    function map(keyPath, valuePath) {
                        return function (item) {
                            if (typeof item === 'undefined'){
                                return;
                            }

                            var href = lodash.get(item, keyPath);

                            return  {
                                id : href,
                                href : href,
                                value : lodash.get(item, valuePath)
                            };
                        }
                    }

                    function getResponseData(response) {
                        return lodash.get(response.getData(), this.responseKeyPath) || [];
                    }

                    function filterResponse(response) {
                        return this.getResponseData(response).map(
                            this.map(this.itemHrefPath, this.itemValuePath)
                        );
                    }
                }]
            };
    })
})();
